import React from 'react';
import { func } from 'prop-types';

export default class Container extends React.Component {
    static propTypes = {
    	render : func.isRequired
    }
    constructor(props){
    	super(props);
    	this.state = {
    		isSidebarOpen : false
    	};
    }

    render() {
    	const {render} = this.props;
    	const onOpenSidebar = (e)=>{
    		this.setState(({
    			isSidebarOpen : true
    		}));
    		e.preventDefault();
    	};
    	const onCloseSidebar = (e)=>{
    		this.setState(({
    			isSidebarOpen : false
    		}));
    		e.preventDefault();
    	};
    	return render({
    		sidebarProps : {
    			onOpenSidebar,
    			onCloseSidebar,
    			isSidebarOpen : this.state.isSidebarOpen
    		}
    	});
    }
}
